import React from "react"
import styled, { ThemeProvider } from 'styled-components'

const Section = styled.section`
    margin: 15px 10px;
    cursor: pointer;

`
const Label = styled.label`
    border-radius:4px;
    background-color:${props => props.theme.bg};
    color: ${props => props.theme.color};
    padding: ${props => props.theme.padding || '8px'};
    font-size: ${props => props.theme.ft || '14px'};
    border: 1px solid ${props => props.theme.color};
    cursor: pointer;
    white-space: nowrap;
`
const Amount = styled.label`
    margin-top: 5px;
    text-align: center;
    display:block;
    cursor: pointer;
    font-size:  ${props => props.theme.font || '17px'};
    min-width: 100px

`
const BoxComponent = ({ bg, color, amount="-", label, ft, padding, id }) =>
    <Section>
        <ThemeProvider theme={{ bg, color, ft, padding }}>
            <Label>{label}</Label>
        </ThemeProvider>
        <br />
        <Amount id={id}>{amount}</Amount>
    </Section>
export default BoxComponent